module.exports = __webpack_public_path__ + "static/media/slides-product.59c57291.jpg";